/**
 * SMSWiser Catalog leads hooks
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import api from '@/services/api';
import { smswiserCatalogKeys } from './smswiserCatalogKeys';
import { useSmswiserCatalogApiEnabled } from './useSmswiserCatalogApiEnabled';
import type { LeadsForFetchResponse, FetchLeadsCountsResult } from './useSmswiserCatalog.types';

export function useLeadsForFetch(countryKeys?: string) {
  const queryEnabled = useSmswiserCatalogApiEnabled(true);
  return useQuery({
    queryKey: smswiserCatalogKeys.leadsForFetch(countryKeys),
    queryFn: async () => {
      const params = countryKeys ? { countryKeys } : {};
      const res = await api.get<{ data: LeadsForFetchResponse }>('/smswiser/catalog/leads-for-fetch', { params });
      return res.data.data;
    },
    enabled: queryEnabled,
  });
}

export function useFetchLeadsCounts() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (params: { countryKeys?: string[]; leadIds?: string[] }) => {
      const res = await api.post<{ data: FetchLeadsCountsResult }>(
        '/smswiser/catalog/fetch-leads-counts',
        params,
        { timeout: 180_000 },
      );
      return res.data.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: smswiserCatalogKeys.all });
    },
  });
}
